import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { Category } from "./_models";

const CATEGORIES = `/api/admin/categories/`;

export const useGetCategories = (options: any = {}) => {
  return useQuery(
    "get-categories",
    async () => {
      const { data } = await axios.get(CATEGORIES);
      return data?.categories;
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};

export const useUpdCategory = () => {
  return useMutation<Category, any, any>(
    "price-dispute",
    async ({ id, category }) => {
      const { data: response } = await axios.patch(
        `${CATEGORIES}${id}/`,
        category
      );
      return response;
    }
  );
};
